// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switcher-container {
  display: flex;
  font-size: 13px;
  margin-bottom: 20px;
}
.switcher-container .sw-opts {
  min-width: 90px;
  padding: 7px;
  border: 1px solid var(--color_primary_500);
  cursor: pointer;
  background-color: var(--base_color2);
  color: var(--color_primary_500);
  text-align: center;
}
.switcher-container .sw-opts:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.switcher-container .sw-opts:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.switcher-container .sw-opts.active {
  color: white;
  color: var(--dashboard_text_color, var(--base_color2, white));
  border-color: var(--color_primary_500);
  font-weight: bold;
  background-color: var(--color_primary_500);
}
.switcher-container .sw-opts.disabled {
  color: var(--gray_light1);
  border-color: var(--gray_light1);
  background-color: var(--base_color2);
}
.switcher-container .sw-opts.disabled.active {
  color: white;
  color: var(--dashboard_text_color, var(--base_color2, white));
  border-color: var(--gray_light1);
  background-color: var(--gray_light1);
}
@media only screen and (max-width: 600px) {
  .switcher-container {
    font-size: 12px;
  }
  .switcher-container .sw-opts {
    min-width: 80px;
    padding: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Switcher/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;EACA,YAAA;EACA,0CAAA;EACA,eAAA;EACA,oCAAA;EACA,+BAAA;EACA,kBAAA;AACJ;AACI;EACE,4BAAA;EACA,+BAAA;AACN;AAEI;EACE,2BAAA;EACA,8BAAA;AAAN;AAGI;EACE,YAAA;EAAA,6DAAA;EACA,sCAAA;EACA,iBAAA;EACA,0CAAA;AADN;AAII;EACE,yBAAA;EACA,gCAAA;EACA,oCAAA;AAFN;AAIM;EACE,YAAA;EAAA,6DAAA;EACA,gCAAA;EACA,oCAAA;AAFR;AAOE;EA5CF;IA6CI,eAAA;EAJF;EAME;IACE,eAAA;IACA,YAAA;EAJJ;AACF","sourcesContent":[".switcher-container {\n  display: flex;\n  font-size: 13px;\n  margin-bottom: 20px;\n\n  .sw-opts {\n    min-width: 90px;\n    padding: 7px;\n    border: 1px solid var(--color_primary_500);\n    cursor: pointer;\n    background-color: var(--base_color2);\n    color: var(--color_primary_500);\n    text-align: center;\n\n    &:last-child {\n      border-top-right-radius: 4px;\n      border-bottom-right-radius: 4px;\n    }\n\n    &:first-child {\n      border-top-left-radius: 4px;\n      border-bottom-left-radius: 4px;\n    }\n\n    &.active {\n      color: var(--dashboard_text_color, var(--base_color2, white));\n      border-color: var(--color_primary_500);\n      font-weight: bold;\n      background-color: var(--color_primary_500);\n    }\n\n    &.disabled {\n      color: var(--gray_light1);\n      border-color: var(--gray_light1);\n      background-color: var(--base_color2);\n\n      &.active {\n        color: var(--dashboard_text_color, var(--base_color2, white));\n        border-color: var(--gray_light1);\n        background-color: var(--gray_light1);\n      }\n    }\n  }\n\n  @media only screen and (max-width: 600px) {\n    font-size: 12px;\n\n    .sw-opts {\n      min-width: 80px;\n      padding: 4px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
